import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'umi';
import { Button, Popconfirm, MessageBox, message } from 'kenshin';
import TablePro from '@/components/TablePro';
import ModalFormPro from '@/components/ModalFormPro';
import UpdateForm from './components/UpdateForm';

/**
 * 标签管理页面
 * 对应接口:
 * - 分页查询: /waper/erp/pc/tasktag/gettasktagpage
 * - 新增: /waper/erp/pc/tasktag/addtasktag
 * - 修改: /waper/erp/pc/tasktag/updatetasktag
 * - 岗位列表: /waper/erp/pc/post/getallpostlist
 */
const TagManage = (props) => {
  const { dispatch, position, tagManage } = props;
  const { allPostList } = position; // 从 position model 获取所有岗位列表

  const [modalVisible, setModalVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const actionRef = useRef();

  // 获取岗位列表数据，用于下拉选择
  useEffect(() => {
    dispatch({ type: 'position/getAllPostList' });
  }, []);

  const handleAdd = () => {
    setCurrentRecord(null);
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    setCurrentRecord(record);
    setModalVisible(true);
  };

  const handleDelete = (tagId) => {
    MessageBox.confirm({
      title: '确认操作',
      content: '确认删除？删除后无法恢复',
      onOk: () => {
        dispatch({
          type: 'tagManage/deleteTaskTag',
          payload: {
            tagId,
          },
        }).then((res) => {
          if (res?.success) {
            actionRef.current?.reload();
          }
        });
      },
    });
  };

  const handleModalOk = (values) => {
    const isEdit = !!currentRecord;
    const type = isEdit ? 'tagManage/updateTaskTag' : 'tagManage/addTaskTag';
    const payload = isEdit
      ? {
          ...values,
          tagId: currentRecord.tagId,
        }
      : values;
    payload.postList = payload.postList.map((id) => ({ id }));
    dispatch({ type, payload }).then((res) => {
      if (res?.success) {
        setModalVisible(false);
        actionRef.current?.reload();
      }
    });
  };

  const columns = [
    {
      title: '标签名称',
      dataIndex: 'tagName',
      key: 'tagName',
      width: '20%',
    },
    {
      title: '标签描述',
      dataIndex: 'tagDesc',
      key: 'tagDesc',
    },
    {
      title: '关联岗位',
      dataIndex: 'postList',
      key: 'postList',
      render: (text) => {
        if (Array.isArray(text)) {
          // 显示岗位名称 (假设对象中有 value 或 postName 字段)
          return text.map((item) => item.value || item.postName).join('，');
        }
        return '-';
      },
    },
    {
      title: '排序',
      dataIndex: 'tagSort',
      key: 'tagSort',
      width: '10%',
    },
    {
      title: '操作',
      width: '10%',
      valueType: 'option',
      key: 'option',
      render: (_, record) => [
        <Button key="edit" type="text" onClick={() => handleEdit(record)}>
          修改
        </Button>,
        <Button
          key="delete"
          type="text"
          style={{ color: 'red' }}
          onClick={() => handleDelete(record.tagId)}
        >
          删除
        </Button>,
      ],
    },
  ];

  return (
    <>
      <TablePro
        headerTitle="标签管理"
        actionRef={actionRef}
        // drag
        // onDrop={(startId,endId,type) => {
        //   // console.log("type...",type);
        //   const tableList = tagManage.tagList.datas;
        //   let sI = tableList.findIndex((item) => item.tagId == startId);
        //   let eI = tableList.findIndex((item) => item.tagId == endId);
        //   console.log(sI,eI);
        //   tableList.splice(eI,0,tableList.splice(sI,1)[0]);
        //   console.log("tableList",tableList);

        // }}
        request="tagManage/getTaskTagPage"
        columns={columns}
        rowKey="tagId"
        data={tagManage.tagList}
        curColumns
        extra={() => [
          <Button type="primary" key="add" onClick={handleAdd}>
            新增
          </Button>,
        ]}
      />
      <UpdateForm
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={handleModalOk}
        initialValues={currentRecord}
        postList={allPostList || []}
      />
    </>
  );
};

export default connect(({ tagManage, position, loading }) => ({
  tagManage,
  position,
  loading: loading.models.tagManage,
}))(TagManage);
